import { useEffect } from 'react'
import getPageSize from 'utils/getPageSize'

interface useInitProps {
  pageSizes: Array<number>
  setDataLoaded: Function
  setShowOverlay: Function
  setDefaultPageSizeObj: Function
  setPageSizesObj: Function
  setValue: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    const defaultPageSize: any = getPageSize()

    const pageSizesObj: any = []
    props.pageSizes.forEach((pageSize) => {
      const pageSizeObj: {} = {
        id: pageSize,
        name: pageSize,
      }
      pageSizesObj.push(pageSizeObj)
      if (defaultPageSize === pageSize) {
        props.setValue('pageSize', pageSizeObj)
      }
    })
    props.setPageSizesObj(pageSizesObj)
    props.setDataLoaded(true)
    props.setShowOverlay(false)
  }, [props.currentCustomer])
}

export default useInit
